var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { createRoot } from 'react-dom/client';
import CustomiserBase from './blocks/CustomiserBase';
const selectors = {
    skeleton: '[data-th-customiser-skeleton]',
    container: '[data-th-customiser-dynamic-container]',
    canvasContainer: '[data-th-customiser-canvas]',
    atcContainer: '[data-th-customiser-atc-modal]',
    templateCopy: '[data-th-customiser-template-copy]',
    templateSettings: '[data-th-customiser-template-settings]',
    storeHeader: 'store-header',
    exportContainer: '[data-th-customiser--export-container]',
    inspoButton: '[data-th-customiser-inspo-btn]',
    designButton: '[data-th-customiser-design-btn]',
    previewButton: '[data-th-customiser-preview-btn]',
    shelf: '[data-th-customiser-shelf]',
};
const initCustomiser = () => __awaiter(void 0, void 0, void 0, function* () {
    const container = document.querySelector(selectors.container);
    const skeleton = document.querySelector(selectors.skeleton);
    const canvasContainer = document.querySelector(selectors.canvasContainer);
    const atcContainer = document.querySelector(selectors.atcContainer);
    const exportContainer = document.querySelector(selectors.exportContainer);
    const inspoButtonContainer = document.querySelector(selectors.inspoButton);
    const designButtonContainer = document.querySelector(selectors.designButton);
    const previewButtonContainer = document.querySelector(selectors.previewButton);
    const shelfContainer = document.querySelector(selectors.shelf);
    if (container && skeleton && canvasContainer && atcContainer && exportContainer) {
        const productHandle = container.dataset.thCustomiserDynamicContainer;
        const templateCopy = JSON.parse(document.querySelector(selectors.templateCopy).textContent);
        const templateSettings = JSON.parse(document.querySelector(selectors.templateSettings).textContent);
        yield fetch(`${window.Shopify.routes.root}products/${productHandle}?view=th-customiser.json`)
            .then((data) => data.json())
            .then((jsonData) => {
            skeleton.classList.add('customiser-loaded');
            const root = createRoot(container);
            return root.render(React.createElement(CustomiserBase, { productData: jsonData, templateCopy: templateCopy, templateSettings: templateSettings, canvasContainer: canvasContainer, atcContainer: atcContainer, exportContainer: exportContainer, inspoButtonContainer: inspoButtonContainer, designButtonContainer: designButtonContainer, previewButtonContainer: previewButtonContainer, shelfContainer: shelfContainer }));
        })
            .catch((error) => {
            skeleton.classList.remove('customiser-loaded');
            console.error('Error loading Customiser: Could not fetch product data', error);
        });
    }
});
export default initCustomiser;
